import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const SelectGoogleAdsAccountPage = lazy(
  () => import('~/features/onboarding/pages/select-google-ads-account-screen'),
);

/** `connectionId` carries through from the connect step (or the Connect
 *  Platforms hub's resume action) — the connection whose account is being
 *  picked. Same pattern as the confirmation route. */
const searchSchema = z.object({
  connectionId: z.string(),
});

function SelectGoogleAdsAccountRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <SelectGoogleAdsAccountPage connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/google-ads/select-account',
)({
  validateSearch: searchSchema,
  component: SelectGoogleAdsAccountRouteComponent,
});
